/* Perro Loco — Carrusel
   ------------------------------------------------------------------
   Un solo comportamiento para todos los carruseles del sitio: el banner
   principal de la home y el banner de cada marca. Antes esto vivía dentro del
   hero; se sacó acá cuando apareció el segundo carrusel, para no tener dos
   copias que se van separando con el tiempo.

   Se engancha solo. El HTML tiene que traer:

     [data-pl-carrusel]     el contenedor
       [data-intervalo]     ms entre diapositivas; 0 o ausente = no rota solo
       [data-pista]         lo que se arrastra con el dedo
         [data-slide]       cada diapositiva (se muestran con `display`)
       [data-ir-a="N"]      los botones del indicador (opcionales)

   Reglas que NO son negociables, todas con motivo:

   - Rotación mínima de 6 segundos. Más rápido no da tiempo a leer.
   - `prefers-reduced-motion` apaga la rotación automática, pero NO el swipe:
     ese lo pide el usuario, no se lo imponemos.
   - Se pausa al pasar el mouse, al enfocar con teclado y con la pestaña
     oculta.
   ------------------------------------------------------------------ */
(function () {
  'use strict';

  function armar(raiz) {
    if (raiz.dataset.plListo) return; // no armar dos veces
    raiz.dataset.plListo = '1';

    var slides = raiz.querySelectorAll('[data-slide]');
    if (slides.length < 2) return;

    var puntos = raiz.querySelectorAll('[data-ir-a]');
    var pista = raiz.querySelector('[data-pista]');
    var actual = 0;
    var timer = null;

    var intervalo = parseInt(raiz.dataset.intervalo, 10) || 0;
    // Nunca por debajo de 6 segundos: es una decisión de diseño, no un default.
    if (intervalo && intervalo < 6000) intervalo = 6000;

    var sinMovimiento = window.matchMedia('(prefers-reduced-motion: reduce)');

    function mostrar(i) {
      actual = (i + slides.length) % slides.length;
      for (var s = 0; s < slides.length; s++) {
        var on = s === actual;
        slides[s].classList.toggle('is-active', on);
        if (on) {
          slides[s].removeAttribute('aria-hidden');
        } else {
          slides[s].setAttribute('aria-hidden', 'true');
        }
      }
      for (var p = 0; p < puntos.length; p++) {
        if (p === actual) {
          puntos[p].setAttribute('aria-current', 'true');
        } else {
          puntos[p].removeAttribute('aria-current');
        }
      }
    }

    function arrancar() {
      if (!intervalo) return;
      if (sinMovimiento.matches) return;
      detener();
      timer = setInterval(function () {
        mostrar(actual + 1);
      }, intervalo);
    }

    function detener() {
      if (timer) {
        clearInterval(timer);
        timer = null;
      }
    }

    for (var i = 0; i < puntos.length; i++) {
      puntos[i].addEventListener('click', function (e) {
        mostrar(parseInt(e.currentTarget.dataset.irA, 10));
        arrancar();
      });
    }

    /* Pasar con el dedo.

       Las diapositivas se muestran con `display`, no en fila, así que no se
       puede arrastrar la imagen y que siga al dedo: se mide el gesto y se
       salta al slide de al lado cuando terminó.

       Tres cuidados:

       1. `touch-action: pan-y` en la pista (está en el CSS). Sin eso el
          navegador se queda con el gesto horizontal y nunca llegan los
          eventos. Con eso, el desplazamiento vertical de la página sigue
          siendo del navegador y la página no se traba.
       2. Solo cuenta como swipe si el movimiento es claramente horizontal. Si
          no, alguien bajando la página con el dedo apoyado en el banner
          cambiaría de slide sin querer.
       3. Los banners suelen ir envueltos en un enlace. Después de un swipe hay
          que anular el clic, o deslizar te manda a la colección. */
    var x0 = null;
    var y0 = null;
    var huboSwipe = false;
    var MINIMO = 40; // menos que eso es un dedo temblando, no una intención

    if (pista && window.PointerEvent) {
      pista.addEventListener('pointerdown', function (e) {
        // Solo dedo o lápiz. Con el mouse ya están los puntos y el teclado.
        if (e.pointerType === 'mouse') return;
        x0 = e.clientX;
        y0 = e.clientY;
        huboSwipe = false;
        detener();
        // Sin esto, un dedo que empieza en el banner y termina fuera nunca
        // dispara el `pointerup`: el gesto queda a medias, el temporizador
        // apagado y el carrusel no vuelve a rotar en toda la visita.
        if (pista.setPointerCapture) {
          try {
            pista.setPointerCapture(e.pointerId);
          } catch (err) {
            /* Navegador viejo: se pierde ese gesto, no la página. */
          }
        }
      });

      pista.addEventListener('pointerup', function (e) {
        if (x0 === null) return;
        var dx = e.clientX - x0;
        var dy = e.clientY - y0;
        x0 = null;
        y0 = null;
        if (Math.abs(dx) >= MINIMO && Math.abs(dx) > Math.abs(dy)) {
          huboSwipe = true;
          mostrar(dx < 0 ? actual + 1 : actual - 1);
        }
        arrancar();
      });

      pista.addEventListener('pointercancel', function () {
        x0 = null;
        y0 = null;
        arrancar();
      });

      // En captura y en la pista: llega antes que el <a> de la diapositiva.
      pista.addEventListener(
        'click',
        function (e) {
          if (!huboSwipe) return;
          huboSwipe = false;
          e.preventDefault();
          e.stopPropagation();
        },
        true
      );
    }

    raiz.addEventListener('mouseenter', detener);
    raiz.addEventListener('mouseleave', arrancar);
    raiz.addEventListener('focusin', detener);
    raiz.addEventListener('focusout', arrancar);

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) {
        detener();
      } else {
        arrancar();
      }
    });

    if (sinMovimiento.addEventListener) {
      sinMovimiento.addEventListener('change', function () {
        if (sinMovimiento.matches) {
          detener();
        } else {
          arrancar();
        }
      });
    }

    arrancar();
  }

  function armarTodos() {
    var todos = document.querySelectorAll('[data-pl-carrusel]');
    for (var i = 0; i < todos.length; i++) armar(todos[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', armarTodos);
  } else {
    armarTodos();
  }

  // El personalizador vuelve a dibujar la sección al editarla; sin esto, el
  // carrusel deja de responder mientras Bryan acomoda los banners.
  document.addEventListener('shopify:section:load', armarTodos);
})();
